app.directive("validateInfo", function() {

    return {
        restrict: "E",
        templateUrl: "/assets/js/angular/components/directives/validateinfo/validateinfo.html?v=8",
        scope: {
            field: "="
        }

    };

});
